import React from 'react';
import ChevronCardButtonList from 'components/ChevronCardButtonList';
import { Grid } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import { StyledShortBody } from 'containers/AUTODashboard/Body/ServicesBloc/styles';
import { sanlamVeryLightgray, sanlamDarkGrayishBlue } from 'Material-UI/colors';
import messages from 'containers/AUTODashboard/Body/ServicesBloc/messages';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { getLocations } from 'store/global/actions';
import { CASABLANCA, FILTERS } from 'components/MapFilter/constants';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export interface ServicesBlocPropsType {
  intl: IntlShape;
  isNewLine?: boolean;
  mdGrid?: any;
  smGrid?: any;
}
const ServicesBloc = (props: ServicesBlocPropsType) => {
  const items = [
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.contactAgent }, props)}
        </StyledShortBody>
      ),
      icon: 'agent',
      path: PAGES.AGENT,
      category: EVENT_CATEGORIES.AUTO_ACCEUIL,
      label: 'Mes Services _Contacter mon agent',
    },
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.approvedGarages }, props)}
        </StyledShortBody>
      ),
      icon: 'Ga',
      path: PAGES.SERVICES,
      category: EVENT_CATEGORIES.AUTO_ACCEUIL,
      label: 'Mes Services _Localiser les garages',
      payload: getLocations({
        filterWith: FILTERS.approvedGarages,
        research: '',
        latitude: CASABLANCA.lat,
        longitude: CASABLANCA.lon,
      }),
    },
    {
      title: (
        <StyledShortBody
          isNewLine={props.isNewLine}
          color={sanlamDarkGrayishBlue}
          weight="500"
        >
          {translate({ ...messages.pin }, props)}
        </StyledShortBody>
      ),
      icon: 'pin',
      path: PAGES.SERVICES,
      category: EVENT_CATEGORIES.AUTO_ACCEUIL,
      label: 'Mes Services _Localiser les CAE',
      payload: getLocations({
        filterWith: FILTERS.checkAutoExpress,
        research: '',
        latitude: CASABLANCA.lat,
        longitude: CASABLANCA.lon,
      }),
    },
  ];
  return (
    <React.Fragment>
      <Grid container>
        <Grid xs={12} item>
          <SmallSectionHeader>
            {translate({ ...messages.myServices }, props)}
          </SmallSectionHeader>
        </Grid>
        <ChevronCardButtonList
          borderColor={sanlamVeryLightgray}
          items={items}
          spacing={2}
          deleteHoverBorder={true}
          mdGrid={props.mdGrid}
          smGrid={props.smGrid}
        />
      </Grid>
    </React.Fragment>
  );
};

export default injectIntl(ServicesBloc);
